<markant-platform-ui-card
  class="management-tile"
  [headline]="'cartridge.management.payment.headline' | transloco"
>
  <div class="payment-data-table">
    <markant-platform-ui-card-item
      *ngIf="price.priceModel"
      class="payment-data-table-item"
      data-cy="payment-card-method"
      [label]="'cartridge.management.payment.method.label' | transloco"
      [title]="
        ('booking.requests.detail.statementOfCosts.model' | transloco) +
        ' : ' +
        ('cartridge.priceModel.' + price.priceModel | transloco) +
        ('cartridge.billingPeriod.' + price.billingPeriod | transloco)
      "
      [inline]="true"
    >
      {{ 'booking.requests.detail.statementOfCosts.model' | transloco }}:
      {{
        ((price | isBulkPrice)
          ? 'booking.requests.detail.statementOfCosts.priceModel.'
          : 'cartridge.priceModel.') + price.priceModel | transloco
      }}
      {{ 'cartridge.billingPeriod.' + price.billingPeriod | transloco }}
    </markant-platform-ui-card-item>
    <markant-platform-ui-card-item
      *ngIf="!(price | isBulkPrice)"
      data-cy="payment-card-price"
      class="payment-data-table-item"
      [label]="'cartridge.management.payment.price.label' | transloco"
      [title]="
        price.centAmount / 100 | translocoCurrency: 'name' : {} : price.currency
      "
      [inline]="true"
    >
      {{
        !!price.centAmount
          ? (price.centAmount / 100
            | translocoCurrency: 'name' : {} : price.currency)
          : (0 | translocoCurrency: 'name' : {} : price.currency)
      }}
      <span *ngIf="price.centAmount">{{
        'cartridge.management.payment.vat' | transloco
      }}</span>
    </markant-platform-ui-card-item>
    <markant-platform-ui-card-item
      *ngIf="setUpCost"
      data-cy="payment-card-setUpCost"
      class="payment-data-table-item"
      [label]="'cartridge.management.payment.setUpCost.label' | transloco"
      [title]="
        setUpCost.centAmount / 100
          | translocoCurrency: 'name' : {} : setUpCost.currency
      "
      [inline]="true"
    >
      {{
        setUpCost.centAmount / 100
          | translocoCurrency: 'name' : {} : setUpCost.currency
      }}
      {{ 'cartridge.management.payment.vat' | transloco }}
    </markant-platform-ui-card-item>
  </div>
</markant-platform-ui-card>
